import React from 'react';
import { GridContext } from './GridRoot';
import type { TItem } from './types';
import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp } from './arrows';
import GridMain from './GridMain';

const nlinux = window.navigator.platform.includes('Linux') ? '' : 'nlinux';
export interface GridPickerProps {
  list?: TItem[];
  cellSize: [number, number];
  pickPostion?: 'bottom' | 'right';
  pageSize: number;
  mainRef: React.RefObject<GridMain>;
}

class GridPicker extends React.Component<GridPickerProps> {
  static contextType = GridContext;

  context!: React.ContextType<typeof GridContext>;

  state = {
    curPage: 0,
  };

  componentDidUpdate(prevProps: GridPickerProps) {
    if (prevProps.list !== this.props.list) {
      const { list, pageSize } = this.props;
      const { curPage } = this.state;
      let _list = list!.slice(curPage * pageSize, (curPage + 1) * pageSize);
      if (curPage !== 0 && _list.length === 0) {
        this.setCurPage(curPage - 1);
      }
    }
  }

  setCurPage = (n: number) => {
    const { pageSize, list } = this.props;
    const min = 0;
    const max = Math.ceil(list!.length / pageSize) - 1;
    this.setState({
      curPage: n < min ? min : n > max ? max : n,
    });
  };

  getPickerStyle = (
    pickPostion: 'bottom' | 'right',
    cellSize: [number, number],
  ) => {
    const pickerStyle: React.CSSProperties =
      pickPostion === 'right'
        ? {
            width: cellSize[0] + 20,
            height: '100%',
            padding: '0 10px',
            flexDirection: 'column',
          }
        : {
            width: '100%',
            height: cellSize[1] + 20,
            padding: '10px 0',
            flexDirection: 'row',
          };

    return pickerStyle;
  };

  // 为保证样式一致性，最后一页可能size未满，补充至pageSize，防止flex布局错乱
  fillSize = (list: TItem[]) => {
    const { pageSize } = this.props;

    if (list.length < pageSize) {
      return [...list, ...Array(pageSize - list.length).fill(null)];
    } else {
      return list;
    }
  };

  render() {
    const {
      list = [],
      cellSize,
      pickPostion = 'bottom',
      pageSize,
    } = this.props;
    const { updatePickItem, updatePickOffset, placeholder } = this.context;
    const { curPage } = this.state;
    let _list = list.slice(curPage * pageSize, (curPage + 1) * pageSize);
    _list = this.fillSize(_list);
    return (
      <div
        className={`grid-picker ${nlinux}`}
        style={this.getPickerStyle(pickPostion, cellSize)}
      >
        {pickPostion === 'bottom' ? (
          <ArrowLeft onClick={() => this.setCurPage(curPage - 1)} />
        ) : (
          <ArrowUp onClick={() => this.setCurPage(curPage - 1)} />
        )}
        {_list.map((item, i) => {
          if (item === null) {
            return (
              <div
                className='grid-picker-item'
                key={i}
                style={{
                  border: 'none',
                  width: cellSize[0],
                  height: cellSize[1],
                }}
              ></div>
            );
          }
          return (
            <div
              className='grid-picker-item'
              draggable
              key={item!.id}
              onDragStart={(e) => {
                // console.log(e.target);
                e.dataTransfer.setData('text/plain', '');
                e.dataTransfer.effectAllowed = 'copy';
                e.dataTransfer.setDragImage(
                  // @ts-ignore
                  e.target.getElementsByTagName('img')[0],
                  20,
                  20,
                );
                const { x, y } = e.currentTarget.getBoundingClientRect();
                updatePickItem(item);
                updatePickOffset({ x: e.pageX - x, y: e.pageY - y });
              }}
              onDragEnd={(e) => {
                updatePickItem(null);
                updatePickOffset(null);
                // linux 下存在 原生dragleave莫名被触发的bug， 导致ondrop不会被触发, 这里手动触发下drap事件 尝试修复它
                if (placeholder) {
                  console.warn('hack takes effect');
                  this.props.mainRef.current?.handleDrop(e);
                }
              }}
              style={{
                width: cellSize[0],
                height: cellSize[1],
              }}
            >
              {item?.renderPick?.() || item!.id}
            </div>
          );
        })}

        {pickPostion === 'bottom' ? (
          <ArrowRight onClick={() => this.setCurPage(curPage + 1)} />
        ) : (
          <ArrowDown onClick={() => this.setCurPage(curPage + 1)} />
        )}
      </div>
    );
  }
}

export default GridPicker;
